import React, { Component } from "react";
// import { DragDropContext } from "react-dnd";
// import HTML5Backend from "react-dnd-html5-backend";
import PropTypes from "prop-types";
import Skill from "./Skill";
import SkillsTarget from "./SkillsTarget";
import withDragDropContext from "../withDragDropContext";

class SkillsContainer extends Component {
		
	render() {
		const { allSkills, userSkills, onChangeSkillValue, dropedNewSkill, removeNewSkill, errors} = this.props;
		return (
			<div className="skills-container">
				<div className="all-skills">
					{ Array.isArray(allSkills) && allSkills.length>0 ?
						allSkills.map((skill, i) => ( <Skill key={skill.id} skill={skill} index={i} /> ))
						:
						<p>No skills are loaded!</p> 
					}
				</div>
				<SkillsTarget 
					userSkills={userSkills} 
					errors={errors}
					onChangeSkillValue={onChangeSkillValue} 
					dropedNewSkill={dropedNewSkill} 
					removeNewSkill={removeNewSkill}/>
			</div>
		);
	}
}

const skill = {
	name: PropTypes.string,
	value: PropTypes.number
};

SkillsContainer.defaultProps = {
	errors: PropTypes.object,
};

SkillsContainer.propTypes = {
	allSkills:PropTypes.arrayOf(PropTypes.shape(skill)).isRequired,
	userSkills:PropTypes.arrayOf(PropTypes.shape(skill)).isRequired,
	errors: PropTypes.shape({
		user_skills: PropTypes.string,
	}),
	onChangeSkillValue:PropTypes.func.isRequired,
	dropedNewSkill:PropTypes.func.isRequired,
	removeNewSkill:PropTypes.func.isRequired,
};


export default withDragDropContext(SkillsContainer);


// WEBPACK FOOTER //
// ./src/components/partials/skills/Container.js